import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {selectSelectedFilter} from '../personSlice';
import {useDeleteBiobookUpdatesMutation} from '../../../app/services/biobookApi';

export const useHandleBiobookUpdates = (userId: number) => {
  const location = useLocation();
  const selectedFilter = useAppSelector(selectSelectedFilter);
  const biobookUpdatesWillBeDeleted = useRef(false);
  const [deleteBiobookUpdates] = useDeleteBiobookUpdatesMutation();

  useEffect(() => {
    return () => {
      if (biobookUpdatesWillBeDeleted.current) {
        biobookUpdatesWillBeDeleted.current = false;
        deleteBiobookUpdates({userId});
      }
    };
  }, [deleteBiobookUpdates, userId]);

  useEffect(() => {
    if (location.pathname.includes('updates')) {
      return () => {
        biobookUpdatesWillBeDeleted.current = true;
      };
    }
  }, [location.pathname]);

  useEffect(() => {
    if (selectedFilter === 'updates') {
      biobookUpdatesWillBeDeleted.current = true;
    }
  }, [selectedFilter]);
};
